export const timePeriod = {
    today: 'Today',
    week: 'This week',
    month: 'This month',
    all: 'All'
};
